var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as React from 'react';
import { observer } from 'mobx-react';
import { observable } from 'mobx';
import styles from './ValidationHint.module.scss';
import { Tooltip } from 'devextreme-react';
import { GoInfo } from 'react-icons/go';
export var ValidationHint = /** @class */ (function (_super) {
    __extends(ValidationHint, _super);
    function ValidationHint() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._isTooltipVisible = false;
        return _this;
    }
    ValidationHint.prototype.render = function () {
        var _a;
        var _this = this;
        var isValid = (_a = this.props, _a.isValid), errors = _a.errors, id = _a.id;
        if (isValid || !errors.some(function (x) { return !!x; }))
            return null;
        return (React.createElement(React.Fragment, null,
            React.createElement("span", { className: styles.letter, onMouseEnter: function () { return (_this._isTooltipVisible = true); }, onMouseLeave: function () { return (_this._isTooltipVisible = false); }, id: id },
                React.createElement(GoInfo, { color: "red", size: "30" })),
            React.createElement(Tooltip, { visible: this._isTooltipVisible, target: "#".concat(id) },
                React.createElement("div", { className: styles.validationInfoWrapper }, errors.map(function (item, number) {
                    return React.createElement("div", { key: id + number }, item);
                })))));
    };
    __decorate([
        observable
    ], ValidationHint.prototype, "_isTooltipVisible", void 0);
    ValidationHint = __decorate([
        observer
    ], ValidationHint);
    return ValidationHint;
}(React.PureComponent));
